import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { TemplateModule } from './template/template.module';
import { TemplateService } from './shared/services/template.service';

// Layout Component -
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';

// Routing Module
import { AppRoutes } from './app.routing';

// App Component
import { AppComponent } from './app.component';
import {RouteGroupTitlePipe} from './shared/pipes/route-group-title.pipe';
import {Forms_Module} from './forms/forms.modules';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule.forRoot(AppRoutes, {useHash: true}),
        SharedModule,
        TemplateModule,
        Forms_Module
    ],
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        AuthenticationLayoutComponent
    ],
    providers: [TemplateService, RouteGroupTitlePipe],
    bootstrap: [AppComponent]
})


export class AppModule { }
